import { createQueryKey } from '../../query/createQueryKeyFactory';
import { QueryKey, QueryKeyParam } from '../../query/types';

const listsKeys = <T extends QueryKey>(keys: T) =>
  createQueryKey({
    all: [...keys] as const,
    id: <U extends QueryKeyParam>(causeId: U) =>
      createQueryKey({
        all: [...keys, causeId] as const,
        backers: [...keys, causeId, 'backers'] as const,
        backersExport: [...keys, causeId, 'backersExport'] as const,
      }),
  });

export { listsKeys };
